import axios, { AxiosInstance } from 'axios';
import { createAuthenticationService } from './services/authenticationService'
import { useLocalStorageStore } from '@/stores/localStorage'

export async function createClient(app): Promise<AxiosInstance> {
    const service = createAuthenticationService(app);
    const accessToken = await service.getAccessToken();
    let language = useLocalStorageStore().getLanguage
    if (!language) {
        language = "de";
    }

    return axios.create({
        timeout: 30000,
        headers: {
            "Content-type": "application/json",
            'DomainId': <string>useLocalStorageStore().getScope || '',
            "Content-Language": language,
            'Authorization': 'Bearer ' + accessToken,
            "Cache-Control": "no-store,no-cache"
        }
    });
}

export async function createNoAuthenticationClient(): Promise<AxiosInstance> {
    const language = useLocalStorageStore().getLanguage || "de";

    return axios.create({
        timeout: 30000,
        headers: {
            "Content-type": "application/json",
            "Content-Language": language,
            "Cache-Control": "no-store,no-cache"
        }
    });
}
